var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"10","offset-md":"1"}},[_c('Stock',{attrs:{"update":true,"id_stock":_vm.$route.params.id}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }